import React, { FunctionComponent, useEffect } from 'react';
import { getIsPlus, getItem, getPosts, getNicknameHistory, reset } from '@stores/user';
import { updateUser, verifyUser } from '@stores/users';
import { useParams, Switch, Route, useHistory } from 'react-router';
import {
  UserInfo,
  UserPosts,
  UserDetailPosts,
  UserDetailGames,
  UserDetailComments,
  UserDetailClaims,
} from '@pages/UserDetailPage';
import IUser from '@interfaces/IUser';
import routes from '@config/routes';
import { getComments } from '@stores/userComments';
import UserAddPlusModal from '@pages/UserDetailPage/UserInfo/UserAddPlusModal';
import UserContinuePlusModal from '@pages/UserDetailPage/UserInfo/UserContinuePlusModal';
import modals, { IModalsState } from '@stores/modals';
import { useStore } from 'effector-react';
import UserChatClaims from '@pages/UserDetailPage/UserChatClaims';
import UserEditModal from '@components/UserEditModal';

interface UserDetailRouteProps {}

const UserDetailRoute: FunctionComponent<UserDetailRouteProps> = () => {
  const { userId } = useParams<{ userId: IUser['id'] }>();

  const {
    visibleState: { plus: visible, continuePlus, user: editUserVisible },
    data,
  } = useStore<IModalsState<any>>(modals);

  useEffect(() => {
    getItem({ userId, clientOptions: { isNotFoundRedirect: true } });
    getPosts({ userId });
    getComments({ userId });
    getIsPlus({ userId });
    return () => reset();
  }, [userId]);

  useEffect(() => {
    const unsubscribeUpdate = updateUser.done.watch(({ params }) => {
      if (String(params.userId) === String(userId)) {
        getItem({ userId });
        getNicknameHistory({ userId });
      }
    });
    const unsubscribeVerify = verifyUser.done.watch(({ params }) => {
      if (String(params.userId) === String(userId)) {
        getItem({ userId });
      }
    });

    return () => {
      unsubscribeUpdate();
      unsubscribeVerify();
    };
  }, [userId]);

  const history = useHistory();

  useEffect(() => {
    return () => {
      if (history.location.pathname.includes(routes.postList.path) && history.action === 'POP') {
        history.goBack();
      }
    };
  });

  return (
    <div>
      <UserInfo />

      <Switch>
        <Route
          exact
          path={routes.userDetail.path}
        >
          <UserPosts />
        </Route>
        <Route
          exact
          path={routes.userDetailPosts.path}
        >
          <UserDetailPosts />
        </Route>
        <Route
          exact
          path={routes.userDetailGames.path}
        >
          <UserDetailGames />
        </Route>

        <Route
          exact
          path={routes.userDetailComments.path}
        >
          <UserDetailComments />
        </Route>

        <Route
          exact
          path={routes.accountClaimsCount.path}
        >
          <UserDetailClaims />
        </Route>

        <Route
          exact
          path={routes.userChatClaims.path}
        >
          <UserChatClaims />
        </Route>
      </Switch>

      {visible ? <UserAddPlusModal /> : null}
      {continuePlus ? <UserContinuePlusModal /> : null}
      {editUserVisible ? <UserEditModal /> : null}
    </div>
  );
};

export default UserDetailRoute;
